import RequestManager from '../../../../requests/RequestManager';
import EpgVersionStatus from '../../../../utils/EpgVersionStatus';
import AddAdminDeviceTask from '../../../../requests/tasks/device/AddAdminDeviceTask'
import store from '../../../../store';
import { AAF_MODAL_LANDING_STB } from '../../../../actions/modal';
import { showModal } from '../../../../actions/modal';
import React, { Component } from 'react';
import { Button, cls } from "../../../../packages/components";
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';

class ButtonActualizarAhora extends Component {
    constructor(props) {
        super(props);
        const region = DeviceStorage.getItem("region");
        this.buttonOnDefault =  Assets.get('LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarAhora_On', '');
        this.buttonOn = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarAhora_On_${region}`, '') || this.buttonOnDefault;
        this.buttonOffDefault =  Assets.get("LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarAhora_Off", '');
        this.buttonOff = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarAhora_Off_${region}`, '') || this.buttonOffDefault;

        this.state = {
            imageOnError: false,
            imageOffError: false,
            focus: false
        }
    }

    render(){
        const { imageOnError, imageOffError, focus } = this.state;
        const { buttonOn, buttonOff, buttonOnDefault, buttonOffDefault } = this;
        const { goBack } = this.props;


        return <Button 
                    type="button"
                    variant="primary"
                    className={cls(
                        `focusable`,
                        'btn',
                        `btn-actualizar-ahora`
                    )}
                    onClick={() => {
                        const task = new AddAdminDeviceTask();
                        RequestManager.addRequest(task).then(data => {
                            (new EpgVersionStatus()).resetApp()
                        }).catch(_ => {
                            const modal = {
                                modalType: AAF_MODAL_LANDING_STB,
                                modalProps: {
                                    callback : () => {
                                        goBack()
                                    },
                                    isError: true
                                }
                            };
                            store.dispatch(showModal(modal));
                        });
                    }}                     
                    onFocus={() => this.setState({focus: true})}
                    onBlur={() => this.setState({focus: false})}

                >
                    <img src={imageOnError ? buttonOnDefault : buttonOn} 
                        onError={imageOnError ? () => {} : () => {
                            this.setState({imageOnError: true})
                        }}
                        style={{display: !focus ? "none" : "block"}}
                    />
                    <img src={imageOffError ? buttonOffDefault : buttonOff} 
                        onError={imageOffError ? () => {} : () => {
                            this.setState({imageOffError: true})
                        }}
                        style={{display: focus ? "none" : "block"}}
                    />
                </Button>
    }
}

export default ButtonActualizarAhora;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/buttons/ButtonActualizarAhora.jsx